<template>
  <page-template>
    <board :is-fold="isFold"
           :http-options="httpOptions"
           :config="config"
           :insert-row-function="() => insertRow('createEmptyNotice')"
           :delete-row-function="(rows) => deleteRow('deleteNotices', rows)"
           :disabled-play-button="true"/>
  </page-template>
</template>

<script>
import Vue from 'vue';

import config from './Config';
import Editor from './detail-row/NoticeEditor';
import CommonBoardItems from '../CommonBoardItems';


Vue.component(config.detailRowComponentName, Editor);

export default {
  name: 'BoardNotice',
  mixins: [CommonBoardItems],
  data() {
    return {
      config,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/board/notice/BoardNotice.vue